import type { FC } from 'react';

import { PsychicStatusText } from 'entities/PsychicStatus';
import { getStatus } from 'lib/psychic.service';

import { StatusTextInterface } from '../config/declarations';

const StatusText: FC<StatusTextInterface> = ({
  psychic,
  className,
  smallTextClass,
  wrapperClass,
  psychicFrame,
}) => {
  const status = getStatus({ chatStatus: psychic.chatStatus, phoneStatus: psychic.phoneStatus });

  return (
    <PsychicStatusText
      psychic={psychic}
      status={status}
      className={className}
      smallTextClass={smallTextClass}
      psychicFrame={psychicFrame}
      wrapperClass={wrapperClass}
    />
  );
};

export default StatusText;
